<template>
  <div class="shopify-auth">
    <img src="../../assets/shopify/shopify.jpeg" alt="" srcset="" />
    <p>{{ $lang('订阅中') }}......</p>
  </div>
</template>

<script>
import { shopifyBindStore } from '@api/base/public'
import { RESPONSE_SUCCESS } from '@constants'
import { mapActions } from 'vuex'
export default {
  name: 'ShopifyAuth',
  data() {
    return {}
  },
  async created() {
    const { code = '', shop = '' } = this.$route.query
    if (code && shop) {
      const shopifyAuthTime = sessionStorage.getItem('shopifyAuthTime')
      if (shopifyAuthTime && new Date().getTime() - shopifyAuthTime <= 3000) {
        // 3s内重复请求就结束
        return false
      }
      sessionStorage.setItem('shopifyAuthTime', new Date().getTime())
      // const user = this.$common.getCookie('tokenInfo')
      this.bindStore(code, shop)
      // const res = await this.shopifyCheckSign(this.$route.query)
      // if (!res) {
      //   // 校验失败  请求真实性异常
      //   this.$message.error('invalid request')
      //   location.href = `https://${shop}`
      //   return false
      // } else if (this.$store.getters.token) {
      //   this.bindStore(code, shop)
      // } else {
      //   sessionStorage.removeItem('shopifyAuthTime')
      //   this.$router.push({ path: '/shopifylogin' })
      // }
    }
  },
  mounted() {},
  methods: {
    ...mapActions(['SET_USER']),
    // async shopifyCheckSign(params) {
    //   const { data = false } = await shopifyCheckSign(params)
    //   return data
    // },
    async bindStore(code, domain) {
      const res = await shopifyBindStore({ code, domain })
      if (res.code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('订阅成功'))
        this.$router.push({ path: '/ExternalOrdersNo' })
      } else {
        this.$message.error(res.msg)
      }
      setTimeout(() => {
        sessionStorage.removeItem('shopifyAuthTime')
      }, 2000)
    }
  }
}
</script>

<style scoped lang="scss">
.shopify-auth {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 18px;
  img {
    width: 200px;
  }
}
</style>
